import AuthService from "../../service/auth/auth_service";
import axios from "axios";

export default class LocalService extends AuthService {
  constructor() {
    super("local");
  }


  findAll() {
    return new Promise((resolve, reject) => {
      if (this.accessMethods.r) {
        axios({
          method: "get",
          url: this.api_url_intra + "local",
          withCredentials: true,
          
        }).then((res) => resolve(res.data));
      } else {
        reject("Acesso negado!");
      }
    });
  }

  findById(id) {
    return new Promise((resolve, reject) => {
      if (this.accessMethods.r) {
        axios({
          method: "get",
          url: this.api_url_intra + "local/" + id,
          withCredentials: true,
        })
          .then((res) => resolve(res.data))
          .catch((err) => reject(err));
      } else {
        reject("Acesso negado!");
      }
    });
  }
  changeStatus(id) {
    return this.execute("PUT", `/status/${id}`);

  }
}
